{{ payPeriod() }}
@if (isCurrent()) {
	<md-tag type="success">Current</md-tag>
}
